// import Lottie from 'lottie-react';
import Image from 'next/image';
import React, { ReactNode, useRef, useState } from 'react';
import { handleTrack } from '../../../utils/tracker';
import { Button, ButtonVariants } from '../../Atoms/Button';
import { If } from '../../Atoms/Conditionals';
import { MarktechModal } from '../../Atoms/Modal';
import { RightArrow } from '../../Icons/rightArrow/RightArrow';
import { Paragraph } from '../../Typography';
import { Video } from '../../Ui';
import { useOnClickOutside } from '../../hooks';
import { AdvertCard } from '../../partner-pages/page-sections/advert-card';
import { ContactUsModal } from '../../partner-pages/page-sections/advert-card/ContactUsModal';
import { ContactUsSection } from '../../partner-pages/page-sections/advert-card/ContactUsSection';
import { AdvertCardStylePartnerPage } from '../../partner-pages/page-sections/advert-card/styles';
// import pricingHeroFold from '../lottie/pricingHeroFold.json';
import { CorporatePage } from '../../../types/partner-page-types';

type TBUTTON = {
  text: string;
  buttonVariant: ButtonVariants;
  type: 'modal' | 'link';
  modalContent?: JSX.Element;
  btnLink?: string;
  arrow?: boolean;
  buttonClasses?: string;
  subText?: string;
};
export type AdvertType = {
  id: number;
  productName: string;
  productDescription: string;
  bulletPoints: string[];
  ctaText: string;
  ctaLink: string;
  bulletImg: string;
  cardClasses: string;
  isActive?: boolean;
};

type feature = {
  imgUrl: string;
  description: string;
};
interface HeroProps extends React.PropsWithChildren {
  heading: string;
  pageType?: string;
  AdvertisedProducts?: AdvertType[];
  headingclass?: string;
  advertCardVisible?: boolean;
  h2Heading?: boolean;
  subHeading?: string;
  imageSource?: string;
  imageClasses?: string;
  videoSource?: string;
  videoSourceWebm?: string;
  videoPoster?: string;
  videoAutoPlay?: boolean;
  videoPlayButton?: boolean;
  btnText?: string;
  btnLink?: string;
  bulletPoint?: string[];
  description?: string;
  descriptionSuffix?: React.ReactNode;
  descriptionClasses?: string;
  companyLogo?: string;
  companyLink?: string;
  children?: ReactNode;
  mediaHeight?: number;
  mediaWidth?: number;
  containerClasses?: string;
  buttons?: TBUTTON[];
  lottieEnabled?: boolean;
  pocEmail?: string;
  pocPhone?: string;
  pocName?: string;
  webinarUrl?: string;
  AdvertisedFeatures?: feature[];
  postData?: CorporatePage;
}

const HeroComponent = ({
  heading,
  AdvertisedProducts = [],
  pocEmail = '',
  pocPhone = '',
  pocName = '',
  webinarUrl = '',
  advertCardVisible = false,
  headingclass = '',
  imageSource = '',
  imageClasses = '',
  videoSource = '',
  videoPoster = '',
  videoSourceWebm = '',
  videoAutoPlay = true,
  videoPlayButton = false,
  buttons,
  h2Heading = false,
  description = '',
  descriptionSuffix = null,
  descriptionClasses = '',
  bulletPoint = [],
  children = '',
  companyLogo = '',
  companyLink = '',
  mediaHeight = 350,
  mediaWidth = 550,
  containerClasses = '',
  AdvertisedFeatures = [],
  postData,
}: HeroProps): JSX.Element => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(<></>);
  const modalRef = useRef(null);
  const [contactUsModal, setContactUsModal] = useState(false);

  useOnClickOutside(modalRef, () => setIsModalVisible(false));
  const onClickButtonHandler = (
    e: React.MouseEvent | React.TouchEvent,
    button: TBUTTON
  ) => {
    handleTrack({ label: 'hero-cta', obj: e?.target });
    if (button.type === 'modal' && button.modalContent) {
      setModalContent(button.modalContent);
      setIsModalVisible(!isModalVisible);
    }
    if (button.btnLink) window.open(button.btnLink);
  };

  return (
    <div
      className={`pt-12 flex justify-between md:pb-0 md:flex-col sm:pt-0 sm:flex-col mx-auto sm:pb-0 sm:px-0 ${containerClasses} ${
        webinarUrl ? '' : 'items-center'
      }`}
    >
      <div className={`mr-4 w-1/2 sm:pl-0 md:w-full sm:w-full sm:pt-4`}>
        <div className="py-6 items-center">
          <If condition={!!companyLogo}>
            <div className="sm:mb-0 mb-4">
              {companyLink ? (
                <a href={companyLink} target="_blank" rel="noreferrer">
                  <img
                    src={companyLogo}
                    alt="logo"
                    height="60"
                    className="h-12 object-contain"
                  />
                </a>
              ) : (
                <img
                  src={companyLogo}
                  alt="logo"
                  height="60"
                  className="h-12 object-contain"
                />
              )}
            </div>
          </If>
        </div>

        {h2Heading ? (
          <h2 className={`${headingclass}`}>{heading}</h2>
        ) : (
          <h1 className={`${headingclass}`}>{heading}</h1>
        )}
        <If condition={!!description}>
          <div className="py-6 sm:pt-5">
            <Paragraph className={descriptionClasses}>{description}</Paragraph>
          </div>
        </If>
        {descriptionSuffix}
        {bulletPoint.length > 0 && (
          <div className="py-4">
            {bulletPoint.map((item) => (
              <div className="flex pt-4 items-center" key={item}>
                <Image
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1655968254_group2630.svg"
                  alt="tick"
                  height="25"
                  width="25"
                />
                <p className="px-2 lg:text-s-18 sm:w-5/6">{item}</p>
              </div>
            ))}
          </div>
        )}

        {children}
        <div className="flex items-center gap-4 sm:flex-col sm:gap-0 sm:items-center">
          {buttons?.map((button) => {
            if (button.type !== 'modal') {
              return (
                <div
                  key={button.text}
                  rel="noreferrer"
                  className={` text-white ${button.buttonClasses} sm:w-full`}
                  onClick={(e) =>
                    handleTrack({ label: 'hero-cta', obj: e?.target })
                  }
                >
                  <a href={button.btnLink}>
                    <Button
                      rounded="sm"
                      className={`focus:outline-none sm:justify-center sm:ml-0 sm:my-0 sm:w-full flex items-center gap-1 ${
                        button.buttonVariant === ButtonVariants.bluetext
                          ? 'px-3 py-0'
                          : `${button.subText ? 'py-2 px-10' : 'px-12 py-3'}`
                      } ${!!button.subText && 'flex-col py-1'}`}
                      id="menu-button"
                      variant={button.buttonVariant}
                    >
                      {button.text}
                      {button.arrow ? (
                        <RightArrow width={18} height={18} />
                      ) : null}
                      <If condition={!!button.subText}>
                        <br></br>
                        <div className="font-normal text-s-12">
                          {button.subText}
                        </div>
                      </If>
                    </Button>
                  </a>
                </div>
              );
            }
            return (
              <div
                key={button.text}
                rel="noreferrer"
                className={` text-white ${button.buttonClasses} sm:w-full`}
                onClick={(e) => onClickButtonHandler(e, button)}
              >
                <Button
                  rounded="sm"
                  className={`focus:outline-none sm:ml-0 sm:w-full flex items-center sm:justify-center gap-1 ${
                    button.buttonVariant === ButtonVariants.bluetext
                      ? 'px-3 py-0'
                      : 'px-12 py-3'
                  }`}
                  id="menu-button"
                  variant={button.buttonVariant}
                >
                  {button.text}{' '}
                  {button.arrow ? <RightArrow width={18} height={18} /> : null}
                </Button>
              </div>
            );
          })}
        </div>

        <If condition={!!AdvertisedFeatures?.length}>
          <div className="flex sm:hidden">
            {AdvertisedFeatures?.map((item, id) => (
              <div key={id} className="w-1/5">
                <img src={item.imgUrl} />
                <div className="font-semibold text-base leading-tight pt-2">
                  {item.description}
                </div>
              </div>
            ))}
          </div>
        </If>
        <If condition={!!pocEmail || !!pocPhone || !!pocName}>
          <ContactUsSection
            setContactUsModal={setContactUsModal}
            className="sm:hidden"
            pocName={pocName}
            pocPhone={pocPhone}
            pocEmail={pocEmail}
          />
        </If>
      </div>
      <If condition={!advertCardVisible}>
        <div className="w-1/2 pr-4 md:px-0 sm:pr-0 md:w-full sm:w-full pl-12 sm:pl-0 sm:pt-7">
          {/* <If condition={lottieEnabled}>
            <Lottie animationData={pricingHeroFold} loop={true} />
          </If> */}
          {imageSource && (
            <img
              src={imageSource}
              className={`mx-auto object-contain ${imageClasses}`}
              alt="hero-image"
              height={mediaHeight}
              width={mediaWidth}
            />
          )}
          {videoSource && (
            <Video
              videoId="actualVideo"
              webmSrc={videoSourceWebm}
              mp4Src={videoSource}
              poster={videoPoster}
              muted={true}
              autoPlay={videoAutoPlay}
              loop={true}
              playBtn={videoPlayButton}
            />
          )}
        </div>
      </If>
      <If condition={advertCardVisible}>
        <AdvertCardStylePartnerPage className="sm:w-auto w-3/5 md:w-auto">
          <AdvertCard
            advertisedProducts={AdvertisedProducts}
            webinarUrl={webinarUrl}
            pocEmail={pocEmail}
            pocPhone={pocPhone}
            pocName={pocName}
            postData={postData}
          />
        </AdvertCardStylePartnerPage>
      </If>
      <MarktechModal
        open={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        closeIcon={'✕'}
        classNames={{
          modal:
            'qnaMaxWidth mobile-bottom-fixed mobile-search-box rounded-2xl h-fit max-h-[95vh] overflow-hidden w-full',
          closeButton: 'text-s-24',
        }}
      >
        <div className="modal rounded-xl modal-open bg-[#F9FAFB]">
          {modalContent}
        </div>
      </MarktechModal>
      <ContactUsModal
        open={contactUsModal}
        onClose={() => setContactUsModal(false)}
        pocEmail={pocEmail}
        pocName={pocName}
        pocPhone={pocPhone}
      />
    </div>
  );
};

export { HeroComponent };
